import React, { useEffect, useState } from "react";
import SearchIcon from "../../icons/SearchIcon";
import { httpReauest } from "../../utils/httpRequest";
import Loading from "../../components/common/Loading";
import { CDN_BASE_URL } from "../../config";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const BrandsMobilePage = () => {
  const [loading, setLoading] = useState();
  const { metaData } = useRouteInfo();

  const [brands, setBrands] = useState();
  const [category, setcategory] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/brand", {}, {}).then(({ data }) => {
      setBrands(data?.data);
    });
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setcategory(data?.data);
    });
    setLoading(false);
  }

  async function handleChange(e) {
    setLoading(true);

    const value = e.target.value;

    await httpReauest("GET", "/brand?search_key=" + value, {}, {}).then(
      ({ data }) => {
        setBrands(data?.data);
      }
    );
    setLoading(false);
  }
  return (
    <div className="pt-2">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <h1 className="title-mobile text-center mb-4">{metaData?.h1}</h1>
      <span className="relative w-full ">
        <input
          className="w-full form-brand px_se xl:min-w-[210px] h-[58px]"
          placeholder="جستجو"
          id="search_key"
          name="search_key"
          onChange={handleChange}
        />
        <img
          src="/Filter.png"
          alt="filter"
          className="absolute translate-y-[-50%] top-[50%] left-4"
        />
        <span className="absolute translate-y-[-50%] top-[50%] right-4">
          <SearchIcon />
        </span>
      </span>
      <div className="py-3 flex justify-center flex-wrap">
        {loading ? (
          <Loading />
        ) : (
          brands?.map((e) => (
            <Link
              to={"/brands/" + e.name}
              className="w-full py-3 border-b border-dashed border-[#8E9192] flex gap-3 items-center"
            >
              <span className="w-[66px] h-[66px] border  rounded-full flex justify-center items-center overflow-hidden border-red-500">
                <img
                  className="w-full h-full object-contain rounded-full"
                  src={CDN_BASE_URL + e?.logo}
                  alt={e?.name}
                />
              </span>
              <span>
                <h3 className="text-[18px] font-bold">{e?.title}</h3>
                <span className="">کامیونت | کامیون | کشنده</span>
              </span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default BrandsMobilePage;
